import React from 'react';

import { type TextAreaHookOptions } from '@pkg/primitives';

import { StaticLabel, StyledUserName } from './UserName.style';

export interface UserNameStaticProps {
    value?: TextAreaHookOptions['initialValue'];
}

export function UserNameStatic(props: UserNameStaticProps) {
    // Value could be `null`, so we are avoiding destructure/assignment.
    const safeValue = props.value ? `${props.value}` : '…';

    return (
        <StyledUserName>
            <StaticLabel>{safeValue}</StaticLabel>
        </StyledUserName>
    );
}
